import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Button } from '../../Button';
import { Input } from '../../Input';
import { ValidationStates } from '../../Input/enums';
import { InputGroup } from '../../InputGroup';
import styles from './PageJumper.scss';
export var PageNumberInput = Input.Number.Small;
export var PageNumberForm = 'form';
export var PageJumper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PageJumper, _React$PureComponent);

  var _super = _createSuper(PageJumper);

  function PageJumper() {
    var _this;

    _classCallCheck(this, PageJumper);

    _this = _super.apply(this, arguments);
    _this.state = {
      inputValue: '',
      invalid: false
    };

    _this.onChange = function (newValue) {
      _this.setState({
        inputValue: newValue
      });
    };

    _this.onSubmit = function (e) {
      var onGoToPage = _this.props.onGoToPage;
      var inputValue = _this.state.inputValue;
      var pageIndex = parseInt(inputValue, 10);

      var isPageIndexValid = _this.isPageIndexValid(pageIndex);

      e.preventDefault();

      if (isPageIndexValid) {
        if (onGoToPage) {
          onGoToPage(pageIndex);
        }

        _this.clearPageNumberInput();
      } else {
        _this.markAsInvalid();
      }
    };

    return _this;
  }

  _createClass(PageJumper, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: styles.container
      }, React.createElement(PageNumberForm, {
        className: styles.form,
        onSubmit: this.onSubmit
      }, React.createElement("div", {
        className: styles.inputContainer
      }, React.createElement(InputGroup, null, React.createElement(InputGroup.Prefix, {
        size: "small",
        disabled: this.props.disabled
      }, React.createElement(InputGroup.Icon, {
        icon: "datatype-numeric"
      })), React.createElement(PageNumberInput, {
        dataTest: "page-number-input",
        placeholder: "Page #",
        value: this.state.inputValue,
        validationState: this.state.invalid ? ValidationStates.Error : ValidationStates.None,
        onChange: this.onChange,
        disabled: this.props.disabled
      }))), React.createElement("span", {
        className: styles.submitContainer
      }, React.createElement(Button, {
        size: "small",
        buttonType: "submit",
        disabled: this.props.disabled,
        dataTest: "page-number-submit-button"
      }, "Go"))));
    }
  }, {
    key: "isPageIndexValid",
    value: function isPageIndexValid(pageIndex) {
      return !Number.isNaN(pageIndex) && pageIndex > 0 && pageIndex <= this.props.totalPageCount;
    }
  }, {
    key: "clearPageNumberInput",
    value: function clearPageNumberInput() {
      this.setState({
        inputValue: '',
        invalid: false
      });
    }
  }, {
    key: "markAsInvalid",
    value: function markAsInvalid() {
      this.setState({
        invalid: true
      });
    }
  }]);

  return PageJumper;
}(React.PureComponent);